import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { StatusPill } from "@/components/StatusPill";

export default function DispatcherIncidents() {
  const [incidents, setIncidents] = useState([]);
  useEffect(() => { api.get("/incidents").then((r) => setIncidents(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="dispatcher-incidents">
      <h1 className="text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Incident Management</h1>
      <div className="grid gap-3">
        {incidents.map((i) => (
          <Card key={i.id} data-testid={`disp-incident-${i.id}`}>
            <CardContent className="p-5">
              <div className="flex items-start justify-between flex-wrap gap-2">
                <div className="flex-1">
                  <div className="font-semibold text-slate-900 capitalize">{i.incident_type.replace(/_/g, " ")}</div>
                  <div className="text-xs text-slate-500 mt-1">{i.facility?.name} · {i.professional ? `${i.professional.first_name} ${i.professional.last_name}` : "—"}</div>
                  <div className="text-sm text-slate-600 mt-2">{i.description}</div>
                  {i.resolution && <div className="text-sm text-green-700 mt-2 bg-green-50 p-2 rounded">Resolution: {i.resolution}</div>}
                </div>
                <div className="flex flex-col gap-2 items-end">
                  <StatusPill status={i.status} />
                  <span className={`status-pill text-[10px] ${i.severity === "high" ? "bg-red-100 text-red-700" : i.severity === "medium" ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-600"}`}>
                    {i.severity}
                  </span>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
        {incidents.length === 0 && <div className="text-center py-16 text-slate-500">No incidents reported.</div>}
      </div>
    </div>
  );
}
